import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';

@Component({
  selector: 'app-alijes-index',
  templateUrl: './alijes-index.component.html',
  styleUrls: ['./alijes-index.component.scss']
})
export class AlijesIndexComponent implements OnInit {

  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
